
const BASE = 'aresLoan-mbBanking.products.loansAndMortgages.productContracting.02_LoanContracting.mbLegalViewer.';

export default {
  BASE,
  MODAL_TITLE: `${BASE}modalTitle`,
  MODAL_CONTINUE_BUTTON: `${BASE}modalNavigationContinueButton`,
  MODAL_CANCEL_BUTTON: `${BASE}modalNavigationCancelLink`,
  PDF_VIEWER_TITLE: `${BASE}modalIneTitle`,
  PDF_VIEWER_CHECKBOX: `${BASE}modalIneDescription`,
};
